import { ActFinishType } from '@/types/ActFinishType';
import { BaseWithSignExecutor } from '../BaseWithSign/BaseWithSignExecutor';

export class ReworkWithSignExecutor extends BaseWithSignExecutor {
    constructor() {
        super();

        this.approveModel = {
            commentIsRequired: true,
            actType: ActFinishType.Rework,
        };
    }
}
